import React from "react";
import ModalPortal from "./ModalPortal";

const ModalManager = () => {
  return <ModalPortal />;
};

export default ModalManager;
